export const SCROLL_PATH = "logged-out-brand/scroll";

export const BRAND_REVIEWS_SECTION_FRAGMENT_IDENTIFIER =
  "brand-reviews-section";
